import styled from 'styled-components';

import theme from './theme';

export const Heading = styled.h2`
  color: ${theme.headingColor};
  text-transform: ${Styles.textTransform.headlines};
`;

export const CenteredText = styled.p`
  text-align: center;
  font-size: 0.9375rem;
  color: ${theme.centeredTextColor};
`;
